export const submitToCollectNew = ({
  accountId,
  userId,
  projectId,
  versionId,
  interactionId,
  message,
  rating,
  userReference,
  source,
  onComplete = ({}) => {},
}) => {
  const myHeaders = new Headers();
  myHeaders.append('Accept', 'application/json');
  myHeaders.append('Content-Type', 'application/json');

  //
  const raw = JSON.stringify(
    {
      accountId,
      userId,
      projectId: `project_${projectId}`,
      versionId: `version_${versionId}`,
      interactionId,
      message,
      ...(rating && { rating }),
      userReference,
      source,
    },
    null,
    2
  );

  // console.log(`%c${raw}`, 'padding:10px;background:red;color:white;');
  //

  const requestOptions: any = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow',
  };

  //
  let endPoint = window?.collectUrl || 'http://localhost:8989/';

  fetch(endPoint, requestOptions)
    .then(response => {
      return response.text();
    })
    .then(result => {
      onComplete(result);
    })
    .catch(error => {
      console.log('error', error);
      onComplete(error);
    });
};

export const submitToCollectClassic = ({
  key,
  rating,
  message,
  identity,
  reference,
  onComplete = ({}) => {},
}) => {
  const myHeaders = new Headers();
  myHeaders.append('Accept', 'application/json');
  myHeaders.append('Content-Type', 'application/json');

  //
  const raw = JSON.stringify(
    {
      key,
      response: {
        ...(rating && { rating }),
        content: message,
        identity,
        reference,
      },
    },
    null,
    2
  );

  const requestOptions: any = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow',
  };

  //
  let endPoint;

  try {
    endPoint =
      window['collectResponseEndpoint'] ||
      window.top!['collectResponseEndpoint'] ||
      'https://collect.chameleoncreator.com/api/v1/responses/create';
  } catch (err) {
    console.log('ERROR GETTING REFERENCE TO COLLECT ENDPOINT :', err);
    //
    endPoint =
      window['collectResponseEndpoint'] ||
      'https://collect.chameleoncreator.com/api/v1/responses/create';
  }

  fetch(endPoint, requestOptions)
    .then(response => {
      return response.text();
    })
    .then(result => {
      onComplete(result);
    })
    .catch(error => {
      console.log('error', error);
      onComplete(error);
    });
};
